import React, { useState } from "react";
import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { Cruise } from "main/javascripts/types/cruise";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { CruiseRouteListMap } from "./CruiseRouteListMap";
import { CruiseRouteList } from "./CruiseRouteList";
import { CruiseRouteListModalDialog } from "main/javascripts/components/cruise/CruiseRouteListModalDialog";
import { accentColor } from "main/javascripts/styles/base/colorStyle";
import { CruiseContentTitle } from "./CruiseContentTitle";

export interface IProps {
  cruise: Cruise.Cruise;
}

export const CruiseRouteListBlock: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { cruise } = props;
  const { t } = useTranslation(["component"]);

  const [isCruiseRoutesModalDisplayed, setIsCruiseRoutesModalDisplayed] =
    useState(false);

  const hideCruiseRoutesModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsCruiseRoutesModalDisplayed(false);
  };

  const displayCruiseRoutesModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsCruiseRoutesModalDisplayed(true);
  };

  return (
    <div css={routesBlockStyle}>
      <CruiseContentTitle>{t("cruise.itinerary")}</CruiseContentTitle>
      <div css={mapBlockStyle}>
        <CruiseRouteListMap cruiseRoutes={cruise.cruiseRoutes} />
        <div css={showItineraryButtonBlockStyle}>
          <div
            css={showItineraryButtonStyle}
            onClick={displayCruiseRoutesModal}
          >
            {t("button:cruise.showEnlargedView")}
          </div>
        </div>
      </div>
      <CruiseRouteList cruiseRoutes={cruise.cruiseRoutes} />

      <CruiseRouteListModalDialog
        displayed={isCruiseRoutesModalDisplayed}
        uniqueId={cruise.uniqueId}
        cruiseRoutes={cruise.cruiseRoutes}
        closeHandler={hideCruiseRoutesModal}
        enableDynamicMap={true}
      />
    </div>
  );
};

const routesBlockStyle = css`
  margin: 0;
`;
const mapBlockStyle = css`
  margin: ${space.atom2x} 0 ${space.atom3x};
  max-width: 600px;
`;
const showItineraryButtonBlockStyle = css`
  display: flex;
  justify-content: flex-start;
  padding: ${space.atom1_5x} 0 0;
`;
const showItineraryButtonStyle = css`
  font-size: ${fontSize.body};
  line-height: ${lineHeight.body2};
  color: ${accentColor.primaryColor};
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 0.5rem;
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 0.8;
  }
`;
